// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh2[data-v-9f530b9a] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
